import { useNavigate } from "react-router-dom";
import Layout from "../../components/global/layout";
import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { useParams } from "react-router-dom";
import loader from "../../methods/loader";
import { Tooltip } from "antd";
import { LiaUserSolid } from "react-icons/lia";
import { MdDateRange, MdOutlineDiscount } from "react-icons/md";
import moment from "moment";
import { MdOutlineEmail, MdOutlinePhone } from "react-icons/md";
import { GrUserSettings } from "react-icons/gr";
import { LuCircleDollarSign } from "react-icons/lu";


const PromoCodeDetail = () => {
  const [data, setData] = useState()
  const history = useNavigate()
  const { id } = useParams()

  useEffect(() => {
    if (id) {
      getPromoCodeDetail()
    }
  }, [])

  const getPromoCodeDetail = () => {
    loader(true);
    ApiClient.get(`promocode/detail?id=${id}`).then((res) => {
      if (res.success) {
        setData(res.data)
      }
      loader(false)
    })
  }

  return (
    <>
      <Layout>
        <div className="wrapper_section bg-white shadow-box rounded-lg w-full p-4">
          <div className="flex items-center mb-8">
            <Tooltip placement="top" title="Back">
              <span
                onClick={() => history(-1)}
                className="!px-4 py-2 cursor-pointer flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3"
              >
                <i className="fa fa-angle-left text-lg"></i>
              </span>
            </Tooltip>
            <div>
              <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">Promo Code Details</h3>
            </div>
          </div>




          <div className="flex flex-col gap-y-6">



            
<div className="col-span-12 md:col-span-6">
    <div className="">
      <p className=" flex md:items-center flex flex-col gap-2 md:flex-row font-semibold capitalize">
        <span className="inline-flex md:w-96 text-md text-gray-600">Name:</span>
        
        <LiaUserSolid className="text-xl text-[#F58D18]" />{data?.name}
      </p>
    </div>
</div>

<div className="col-span-12 md:col-span-6">
    <div className="">
      <p className=" flex md:items-center flex flex-col gap-2 md:flex-row font-semibold">
        <span className="inline-flex md:w-96 text-md text-gray-600">Code:</span>
        
        <LiaUserSolid className="text-xl text-[#F58D18]" />{data?.code || "--"}
      </p>
    </div>
</div>



<div className="col-span-12 md:col-span-6">
<div className="">
        <p className=" flex md:items-center flex flex-col gap-2 md:flex-row font-semibold">
        <span className="inline-flex md:w-96 text-md text-gray-600">Total Applied:</span>
        <MdOutlineDiscount className="text-xl text-[#F58D18]" />{data?.totalApplied}
        </p>
      </div>
</div>

<div className="col-span-12 md:col-span-6">
<div className="">
        <p className=" flex md:items-center flex flex-col gap-2 md:flex-row font-semibold">
        <span className="inline-flex md:w-96 text-md text-gray-600">Discount:</span>
        <LuCircleDollarSign className="text-xl text-[#F58D18]" />{data?.discountId?.name}
        </p>
      </div>
</div>

<div className="col-span-12 md:col-span-6">
<div className="">
        <p className=" flex md:items-center flex flex-col gap-2 md:flex-row font-semibold">
        <span className="inline-flex md:w-96 text-md text-gray-600">Stare Date:</span>
        <MdDateRange className="text-xl text-[#F58D18]" />{moment(data?.startDate).format("LL")}
        </p>
      </div>
</div>

<div className="col-span-12 md:col-span-6">
<div className="">
        <p className=" flex md:items-center flex flex-col gap-2 md:flex-row font-semibold">
        <span className="inline-flex md:w-96 text-md text-gray-600">End Date:</span>
        <MdDateRange className="text-xl text-[#F58D18]" />{moment(data?.endDate).format("LL")}
        </p>
      </div>
</div>






</div>



       
        </div>
      </Layout>
    </>
  );
};

export default PromoCodeDetail;
